<template>
  <div :class="$style.quickfinder">
    <QuickfinderFlyout :list-items="listItems" @[toogleMenu]="setActiveState">
      <QuickfinderButton :is-active="isActive" />
    </QuickfinderFlyout>
  </div>
</template>

<script>
import { filter, get } from 'lodash-es'
import API_CONSTANTS from '@/js/helper/api-constants.js'

import { parseDataAttributeJson } from '@/js/helper/data-attribute-helper.js'
import { getAllNavigationItems } from '@/js/helper/navigation-helper.js'

import QuickfinderFlyout from '@/js/components/Quickfinder/QuickfinderFlyout.vue'
import QuickfinderButton from '@/js/components/Quickfinder/QuickfinderButton.vue'

import QUICKFINDER_CONSTANTS from './utils/quickfinder-constants.js'

export default {
  name: 'QuickfinderMenu',
  components: {
    QuickfinderFlyout,
    QuickfinderButton,
  },
  props: {
    element: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ...parseDataAttributeJson(this.element),
      toogleMenu: QUICKFINDER_CONSTANTS.ACTIONS.TOGGLE_MENU,
      isActive: false,
    }
  },
  computed: {
    allNavigationItems() {
      const filterCallback = key => key === API_CONSTANTS.ELEMENTS

      return getAllNavigationItems(this.relationships, filterCallback)
    },
    listItems() {
      return filter(this.allNavigationItems, {
        type: API_CONSTANTS.NAVIGATION.ICON_TEXT_TYPE,
      }).map(item => get(item, API_CONSTANTS.ATTRIBUTES))
    },
  },
  methods: {
    setActiveState(value) {
      this.isActive = value
    },
  },
}
</script>

<style lang="scss" module>
.quickfinder {
  position: fixed;
  top: 15rem;
  right: 1rem;
  z-index: 4;

  border-radius: 100%;
  box-shadow: 3px 3px 10px 0 hsla(0, 0%, 0%, 0.3) !important;
}
</style>
